const FilledArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      width="16"
      height="16"
    >
      <path d="M4.5 6.75L9 11.25L13.5 6.75" fill="currentColor"></path>
      <path
        d="M4.5 6.75L9 11.25L13.5 6.75H4.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default FilledArrow;
